import * as React from "react";
import {
  View,
  Text,
  TouchableOpacity,
  ActivityIndicator,
  StyleSheet,
} from "react-native";
import Colors from "../constants/Colors";
import FontStyles from "../constants/FontStyle";

export type StyledButtonColorTypes =
  | "default"
  | "light"
  | "dark"
  | "success"
  | "successInverted"
  | "warning"
  | "danger"
  | "dangerInverted"
  | "transparent";

interface IProps {
  label: string | React.ReactElement;
  color?: StyledButtonColorTypes;
  size?: "lg" | "sm";
  disabled?: boolean;
  submitting?: boolean;
  action?: Function;
  style?: any;
}

const StyledButton: React.FC<IProps> = function ({
  color = "default",
  size = "lg",
  disabled,
  submitting,
  label,
  action,
  style,
}) {
  const colorPicker = (val: string) => {
    let _color = Colors.darkTextColor;
    switch (val) {
      case "default":
        _color = Colors.whiteColor;
        break;
      case "dark":
        _color = Colors.whiteColor;
        break;
      case "success":
        _color = Colors.dangerText;
        break;
      case "warning":
        _color = Colors.dangerText;
        break;
      case "danger":
        _color = Colors.dangerText;
        break;
      case "transparent":
        _color = Colors.darkTextColor;
        break;
      default:
        _color = Colors.whiteColor;
        break;
    }
    return _color;
  };

  return (
    <>
      <TouchableOpacity
        style={[
          styles.button,
          styles[color],
          styles[size],
          { opacity: disabled ? 0.8 : 1 },
          style,
        ]}
        onPress={() => action && action()}
        disabled={disabled}
      >
        {submitting ? (
          <View style={{ flexDirection: "row", justifyContent: "center" }}>
            <Text
              style={[
                styles.buttonText,
                styles[color],
                {
                  backgroundColor: "transparent",
                  alignSelf: "center",
                  marginRight: 10,
                },
              ]}
            >
              {" "}
              Please wait{" "}
            </Text>
            <ActivityIndicator
              style={[{ alignSelf: "center" }]}
              color={colorPicker(color)}
            ></ActivityIndicator>
          </View>
        ) : typeof label === "string" ? (
          <Text
            style={[
              styles.buttonText,
              styles[color],
              { backgroundColor: "transparent", borderColor: "transparent" },
            ]}
          >
            {label}
          </Text>
        ) : (
          label
        )}
      </TouchableOpacity>
    </>
  );
};

StyledButton.defaultProps = {
  color: "default",
  size: "lg",
};

export default StyledButton;

const styles = StyleSheet.create({
  button: {
    paddingVertical: 13,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 6,
  },
  buttonText: {
    ...FontStyles.size13,
    ...FontStyles.lh18,
    ...FontStyles.semibold,
    alignSelf: "center",
    textAlignVertical: "bottom",
    textAlign: "center",
    paddingHorizontal: 20,
  },
  default: { backgroundColor: Colors.tintColor, color: Colors.whiteColor },
  defaultOutline: {
    backgroundColor: Colors.whiteColor,
    color: Colors.tintColor,
    borderStyle: "solid",
    borderColor: Colors.tintColor,
    borderWidth: 1,
  },
  dark: { backgroundColor: Colors.darkColor, color: Colors.whiteColor },
  light: {
    backgroundColor: Colors.shades._5,
    color: Colors.shades._2,
    borderColor: Colors.shades._6,
    borderStyle: "solid",
    borderWidth: 1,
  },
  white: { backgroundColor: "white", color: Colors.darkTextColor },
  transparent: { backgroundColor: "transparent", color: Colors.darkTextColor },
  success: {
    backgroundColor: Colors.successBackground,
    color: Colors.successText,
  },
  successInverted: {
    backgroundColor: Colors.successText,
    color: Colors.whiteColor,
  },
  warning: {
    backgroundColor: Colors.warningBackground,
    color: Colors.warningText,
  },
  danger: {
    backgroundColor: Colors.dangerBackground,
    color: Colors.dangerText,
  },
  dangerInverted: {
    backgroundColor: Colors.dangerText,
    color: Colors.whiteColor,
  },
  sm: { width: 160 },
  lg: { width: "100%" },
});
